export var FileType;
(function (FileType) {
    FileType["CSS"] = "css";
    FileType["HTML"] = "html";
    FileType["JS"] = "js";
    FileType["JSON"] = "json";
    FileType["VUE"] = "vue";
    FileType["TS"] = "ts";
    FileType["TSX"] = "tsx";
})(FileType || (FileType = {}));
export var ChunkType;
(function (ChunkType) {
    ChunkType["AST"] = "ast";
    ChunkType["HAST"] = "hast";
    ChunkType["STRING"] = "string";
})(ChunkType || (ChunkType = {}));
export var PreactStyleVariation;
(function (PreactStyleVariation) {
    PreactStyleVariation["InlineStyles"] = "Inline Styles";
    PreactStyleVariation["CSSModules"] = "CSS Modules";
    PreactStyleVariation["CSS"] = "CSS";
})(PreactStyleVariation || (PreactStyleVariation = {}));
export var ReactStyleVariation;
(function (ReactStyleVariation) {
    ReactStyleVariation["InlineStyles"] = "Inline Styles";
    ReactStyleVariation["CSSModules"] = "CSS Modules";
    ReactStyleVariation["CSS"] = "CSS";
    ReactStyleVariation["StyledComponents"] = "Styled Components";
    ReactStyleVariation["StyledJSX"] = "Styled JSX";
    ReactStyleVariation["ReactJSS"] = "React JSS";
})(ReactStyleVariation || (ReactStyleVariation = {}));
export var ReactNativeStyleVariation;
(function (ReactNativeStyleVariation) {
    ReactNativeStyleVariation["InlineStyles"] = "Inline Styles";
    ReactNativeStyleVariation["StyledComponents"] = "Styled Components";
})(ReactNativeStyleVariation || (ReactNativeStyleVariation = {}));
export var PublisherType;
(function (PublisherType) {
    PublisherType["DISK"] = "Disk";
    PublisherType["ZIP"] = "Zip";
    PublisherType["VERCEL"] = "Vercel";
    PublisherType["NETLIFY"] = "Netlify";
    PublisherType["GITHUB"] = "Github";
    PublisherType["CODESANDBOX"] = "CodeSandbox";
})(PublisherType || (PublisherType = {}));
export var GatsbyStyleVariation;
(function (GatsbyStyleVariation) {
    GatsbyStyleVariation["CSSModules"] = "CSS Modules";
    GatsbyStyleVariation["StyledComponents"] = "Styled Components";
})(GatsbyStyleVariation || (GatsbyStyleVariation = {}));
export var ProjectType;
(function (ProjectType) {
    ProjectType["REACT"] = "React";
    ProjectType["NEXT"] = "Next";
    ProjectType["VUE"] = "Vue";
    ProjectType["NUXT"] = "Nuxt";
    ProjectType["PREACT"] = "Preact";
    ProjectType["STENCIL"] = "Stencil";
    ProjectType["ANGULAR"] = "Angular";
    ProjectType["GATSBY"] = "Gatsby";
    ProjectType["GRIDSOME"] = "Gridsome";
    ProjectType["REACTNATIVE"] = "React-Native";
    ProjectType["NEXT_REACT_JSS"] = "Next-React-JSS";
    ProjectType["NEXT_CSS_MODULES"] = "Next-CSSModules";
    ProjectType["NEXT_STYLED_COMPONENTS"] = "Next-StyledComponents";
    ProjectType["GATSBY_STYLED_COMPONENTS"] = "Gatsby-StyledComponents";
})(ProjectType || (ProjectType = {}));
export var ComponentType;
(function (ComponentType) {
    ComponentType["REACT"] = "React";
    ComponentType["VUE"] = "Vue";
    ComponentType["PREACT"] = "Preact";
    ComponentType["STENCIL"] = "Stencil";
    ComponentType["ANGULAR"] = "Angular";
    ComponentType["REACTNATIVE"] = "React-Native";
})(ComponentType || (ComponentType = {}));
export const DefaultStyleVariation = {
    [ComponentType.REACT]: ReactStyleVariation.CSSModules,
    [ComponentType.PREACT]: PreactStyleVariation.CSSModules,
    [ComponentType.REACTNATIVE]: ReactNativeStyleVariation.StyledComponents,
    [ComponentType.VUE]: null,
    [ComponentType.STENCIL]: null,
    [ComponentType.ANGULAR]: null,
};
//# sourceMappingURL=generators.js.map